import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiMenu, HiX } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";

import logo from "../../assets/blue_logo.svg";
import { getLanguage } from "../../utils/getLanguage";
import LanguageSwitcher from "../LanguageSwitcher";

const AuthHeader = () => {
  const { t } = useTranslation();
  const lang = getLanguage();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => pathname === path || pathname.startsWith(path + "/");

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-y-4 px-6 py-3 md:flex-nowrap">
        {/* Logo + Hamburger */}
        <div className="flex w-full items-center justify-between md:w-auto md:gap-12">
          <Link to={`/${lang}`}>
            <img src={logo} alt="HelloCode" className="w-12 md:w-24" />
          </Link>
          <button
            className="text-2xl text-gray-700 md:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            {menuOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>

        {/* Nav Menu - mobile toggle + desktop always visible */}
        <nav
          className={`w-full flex-col items-start gap-6 text-sm font-medium text-gray-700 md:mx-6 md:flex md:flex-row md:items-center md:justify-start ${
            menuOpen ? "flex" : "hidden"
          }`}
        >
          <Link
            to={`/${lang}`}
            className={`block transition hover:text-blue-600 ${
              pathname === `/${lang}` ? "font-semibold text-blue-600" : ""
            }`}
          >
            {t("home")}
          </Link>
          {/* <Link
            to={`/${lang}/courses`}
            className={`block transition hover:text-blue-600 ${
              isActive(`/${lang}/courses`) ? "font-semibold text-blue-600" : ""
            }`}
          >
            {t("courses")}
          </Link> */}
          {/* <Link
            to={`/${lang}/schools`}
            className={`block transition hover:text-blue-600 ${
              isActive(`/${lang}/schools`) ? "font-semibold text-blue-600" : ""
            }`}
          >
            {t("for_schools")} <span className="text-sm">↗</span>
          </Link> */}
          {/* <Link
            to={`/${lang}/certificates`}
            className={`block transition hover:text-blue-600 ${
              isActive(`/${lang}/certificates`) ? "font-semibold text-blue-600" : ""
            }`}
          >
            {t("certificates")}
          </Link> */}
          {/* <Link
            to={`/${lang}/pricing`}
            className={`block transition hover:text-blue-600 ${
              isActive(`/${lang}/pricing`) ? "font-semibold text-blue-600" : ""
            }`}
          >
            {t("pricing")}
          </Link> */}

          {/* Language switcher on mobile */}
          <div className="mt-4 block md:hidden">
            <LanguageSwitcher />
          </div>

          {/* Auth buttons on mobile */}
          <div className="mt-2 flex w-full flex-col gap-2 md:hidden">
            {/* <Link className="w-full rounded-full border border-blue-500 px-4 py-2 text-center text-sm font-medium text-blue-500 transition hover:bg-blue-50">
              {t("register")}
            </Link> */}
            <Link
              to={`/${lang}/login`}
              className="wavy-btn relative w-full rounded-3xl border-2 border-[#e6bc40] bg-[#FFD03F] px-4 py-2 text-center text-sm font-semibold text-gray-800 transition duration-200 hover:bg-[#ffdd78]"
            >
              {t("login")}
            </Link>
          </div>
        </nav>

        {/* Language + Auth (desktop only) */}
        <div className="hidden w-full items-center justify-end gap-2 md:flex">
          <LanguageSwitcher />
          {/* <Link className="rounded-full border border-blue-500 px-4 py-2 text-sm font-medium text-blue-500 transition hover:bg-blue-50">
            {t("register")}
          </Link> */}
          <Link
            to={`/${lang}/login`}
            className="wavy-btn relative rounded-3xl border-2 border-[#e6bc40] bg-[#FFD03F] px-10 py-2 text-sm font-semibold text-gray-800 transition duration-200 hover:bg-[#ffdd78]"
          >
            {t("login")}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
